export default __webpack_public_path__ + "static/media/marek-szturc-n3qWOO_WO3E-unsplash.fe5c4f42.jpg";